export { default } from './InviteFriend.container';
export { default as InviteFriend } from './InviteFriend';
